import { render, staticRenderFns } from "./FormatLookUp.vue?vue&type=template&id=82835988&scoped=true"
import script from "./FormatLookUp.vue?vue&type=script&lang=js"
export * from "./FormatLookUp.vue?vue&type=script&lang=js"
import style0 from "./FormatLookUp.vue?vue&type=style&index=0&id=82835988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82835988",
  null
  
)

export default component.exports